import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useGetSkjemaErrorTitleAndBodyFromResources } from 'src/hooks/useGetSkjemaErrorTitle';
import { useResources } from 'src/resources';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { dismissLagreError } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

export const LagreSkjemaErrorModal = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const lagreSkjemaError = useAppSelector(state => state.refero.ui.lagreSkjemaError);
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const confirmationActionButton = resources?.confirmationActionButton;
  const lagreSkjemaErrorCode = useAppSelector(state => state.refero.ui.lagreSkjemaErrorCode);

  const errorTekst = useGetSkjemaErrorTitleAndBodyFromResources({
    bodyKey: 'lagreSkjemaErrorBody',
    titleKey: 'lagreSkjemaErrorTitle',
    error: lagreSkjemaError,
    errorCode: lagreSkjemaErrorCode,
  });
  const onLagreErrorClose = (): void => {
    dispatch(dismissLagreError());
  };
  return lagreSkjemaError && errorTekst ? (
    <Modal
      variant="error"
      testId="lagre-skjema-error"
      onClose={onLagreErrorClose}
      title={errorTekst.errorTitle}
      description={errorTekst.errorBody}
      onSuccess={onLagreErrorClose}
      primaryButtonText={confirmationActionButton}
    />
  ) : null;
};
export default LagreSkjemaErrorModal;
